import { isDevMode } from '@angular/core';
import { environment } from 'src/environments/environment';

export const DEFAULT_CLIENT = 'gmu';
export const DEFAULT_IMAGE_FOLDER = 'gmu';

/** Nombres de archivo fijos por convención en /content/images/{carpeta}/ */
export const CLIENT_IMAGE_FILES = {
  header: 'logo4.png',
  panel: 'logo-panel.png',
  head: 'logo-head.png',
  footer: 'logo-footer.png',
  escudo: 'logo-escudo.png',
  favicon: 'favicon.ico',
  icon: 'logo-icon.png',
} as const;

export type ClientImageAsset = keyof typeof CLIENT_IMAGE_FILES;

/** Variables CSS de fondo que apuntan a los logos del cliente */
export const CLIENT_IMAGE_CSS_VARS: Record<string, ClientImageAsset> = {
  '--url-logo-header': 'header',
  '--url-logo-panel': 'panel',
  '--url-logo-head': 'head',
  '--url-logo-footer': 'footer',
  '--url-escudo': 'escudo',
};

export function getStaticBasePath(): string {
  return environment.STATIC_BASE_PATH ?? '';
}

export function getContentBasePath(): string {
  const base = getStaticBasePath();
  return base ? `${base}/content` : '/content';
}

export function getI18nBasePath(): string {
  const base = getStaticBasePath();
  return base ? `${base}/i18n` : '/i18n';
}

export function getClienteApiUrl(): string {
  return`${environment.API_URL}/api/cliente`;
}

export function getClientImagePath(clientName: string, fileName: string): string {
  return `${getContentBasePath()}/images/${clientName}/${fileName}`;
}

/** Normaliza rutas de assets públicos (footer, certificados, sliders/cards de BD). */
export function resolvePublicAssetPath(path: string | null | undefined): string {
  if (!path) {
    return '';
  }
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  let relative = path;
  while (relative.startsWith('./')) {
    relative = relative.substring(2);
  }
  const base = getStaticBasePath();
  const normalized = relative.startsWith('/') ? relative : `/${relative}`;
  return base ? `${base}${normalized}` : normalized;
}
